import React from "react";
import { ContainerDetailsWindow, IContainerDetailsWindowProps } from "./ContainerDetailsWindow";
import throttle from 'lodash.throttle';
import { EVENT_HANDLER_THROTTLE_TIME, LIVE_PERFORMANCE_PAGE_VIEW } from "../../../repertoire/Consts";
import { LivePerformanceContainerDetailsWindow } from "./LivePerformanceContainerDetailsWindow";
import { UploadCueSheetsContainerDetailsWindow } from "./UploadCueSheetsContainerDetailsWindow";
import { UploadBulkWorksContainerDetailsWindow } from "./UploadBulkWorksContainerDetailsWindow";
import { UPLOAD_BULK_WORKS_PAGE_VIEW, UPLOAD_CUE_SHEETS_PAGE_VIEW } from "../../../membersportal/Consts";

interface IAdditionalProps {
    renderDragFilesUpload?: boolean
}

type IScrollEventListenerWrapperProps = IContainerDetailsWindowProps & IAdditionalProps;

const ScrollEventListenerWrapperContainerDetailsWindow: React.FC<IScrollEventListenerWrapperProps> = (props) => {

    const [updatedScroll, setUpdatedScroll] = React.useState(0);
	const handleScroll = React.useCallback(() => {
        setUpdatedScroll(window.scrollY);
    }, []);

    React.useEffect(() => {
        const throttledHandleScroll = throttle(
            handleScroll,
            EVENT_HANDLER_THROTTLE_TIME,
            { trailing: true }
        );

        window.addEventListener("scroll", throttledHandleScroll);

        return () => {
            window.removeEventListener("scroll", throttledHandleScroll);
            throttledHandleScroll.cancel();
        };
    }, [handleScroll]);

	switch (props.component) {
        case LIVE_PERFORMANCE_PAGE_VIEW:
            return (
                <LivePerformanceContainerDetailsWindow
                    {...props}
                    updatedScroll={updatedScroll}
                />
            );

        case UPLOAD_CUE_SHEETS_PAGE_VIEW:
            return (
                <UploadCueSheetsContainerDetailsWindow
                    {...props}
                    updatedScroll={updatedScroll}
                />
            );

        case UPLOAD_BULK_WORKS_PAGE_VIEW:
            return (
                <UploadBulkWorksContainerDetailsWindow
                    {...props}
                    updatedScroll={updatedScroll}
                />
            );

        default:
            return (
                <ContainerDetailsWindow
                    {...props}
                    updatedScroll={updatedScroll}
                />
            );
    }    
}
export default ScrollEventListenerWrapperContainerDetailsWindow;